import { currentIntlLocale } from "./i18n";

export const formatDateTime = (value?: string | null) => {
  if (!value) return "-";
  return new Intl.DateTimeFormat(currentIntlLocale(), {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));
};

export const formatDate = (value?: string | null) => {
  if (!value) return "-";
  return new Intl.DateTimeFormat(currentIntlLocale(), {
    weekday: "short",
    day: "2-digit",
    month: "short",
  }).format(new Date(value));
};

export const percent = (value: number, total: number) => {
  if (!total) return "0%";
  return `${Math.round((value / total) * 100)}%`;
};
